// Mock data for TouchScreenMD

export const mockServices = [
  {
    id: 1,
    title: "Primary Care",
    description: "Routine checkups, preventive care, and ongoing health management with licensed providers.",
    icon: "Stethoscope"
  },
  {
    id: 2,
    title: "Urgent Care",
    description: "Fast treatment for non-emergency conditions like colds, flu, infections, and minor injuries.",
    icon: "Clock"
  },
  {
    id: 3,
    title: "Mental Health",
    description: "Confidential support for anxiety, depression, stress management, and behavioral health.",
    icon: "Brain"
  },
  {
    id: 4,
    title: "Chronic Care",
    description: "Ongoing management for diabetes, hypertension, asthma, and other chronic conditions.",
    icon: "Activity"
  },
  {
    id: 5,
    title: "Prescription Refills",
    description: "Quick and easy medication refills sent directly to your preferred pharmacy.",
    icon: "Pill"
  },
  {
    id: 6,
    title: "Laboratory Services",
    description: "Order lab tests, receive results, and get expert interpretation from healthcare providers.",
    icon: "FlaskConical"
  },
  {
    id: 7,
    title: "Lab Review",
    description: "Review and discuss your lab results with a licensed healthcare provider.",
    icon: "ClipboardList"
  }
];

export const mockPricing = [
  {
    id: 1,
    title: "Insurance & Medicaid",
    description: "Use your insurance or Medicaid coverage",
    price: "Copay only",
    features: [
      "Standard copay applies",
      "Most major insurance accepted",
      "Medicaid in select states",
      "Direct billing to insurance"
    ],
    buttonText: "Check Coverage",
    highlighted: false
  },
  {
    id: 2,
    title: "Membership",
    description: "Unlimited access for you and your family",
    price: "$29/month",
    features: [
      "Unlimited virtual visits",
      "No per-visit fees",
      "24/7 provider access",
      "Includes up to 5 family members"
    ],
    buttonText: "Get Started",
    highlighted: true
  },
  {
    id: 3,
    title: "Pay Per Visit",
    description: "Pay as you go with transparent pricing",
    price: "$79/visit",
    features: [
      "No subscription required",
      "Transparent pricing",
      "Pay only when you need care",
      "Credit cards accepted"
    ],
    buttonText: "Start a Visit",
    highlighted: false
  }
];

export const mockHowItWorks = [
  {
    id: 1,
    step: "1",
    title: "Answer a few questions",
    description: "Complete a quick intake form so your provider can help you faster. Takes less than 2 minutes."
  },
  {
    id: 2,
    step: "2",
    title: "Connect with a provider",
    description: "Meet with a licensed healthcare provider through a secure video call. Average wait time under 10 minutes."
  },
  {
    id: 3,
    step: "3",
    title: "Get your care plan",
    description: "Receive guidance, prescriptions if needed, and follow-up instructions. Prescriptions sent to your pharmacy."
  }
];

export const mockFAQs = [
  {
    id: 1,
    question: "What conditions can you treat?",
    answer: "We treat a wide range of conditions including cold and flu, infections, allergies, mental health concerns, chronic disease management, skin conditions, and much more. If you're unsure, start a visit and our providers will help determine if telehealth is appropriate."
  },
  {
    id: 2,
    question: "Do you accept my insurance?",
    answer: "We accept most major insurance plans including Aetna, Cigna, Blue Cross Blue Shield, UnitedHealthcare, and more. Medicaid is accepted in select states. Use our coverage checker to verify your specific plan."
  },
  {
    id: 3,
    question: "How long does a visit take?",
    answer: "Most visits last 10-15 minutes. You'll typically connect with a provider within 10 minutes of starting your visit, though wait times may vary based on demand."
  },
  {
    id: 4,
    question: "Can you prescribe medications?",
    answer: "Yes, our licensed providers can prescribe medications when medically appropriate and permitted by law. Prescriptions are sent electronically to your preferred pharmacy. Some controlled substances may not be available via telehealth."
  },
  {
    id: 5,
    question: "Is this for emergencies?",
    answer: "No. TouchScreenMD is not for medical emergencies. If you're experiencing chest pain, severe shortness of breath, stroke symptoms, major bleeding, or other life-threatening conditions, call 911 or go to the nearest emergency room immediately."
  },
  {
    id: 6,
    question: "Is my information secure?",
    answer: "Yes. We use industry-standard safeguards designed to protect your personal health information. Our platform is designed with strong privacy protections and we comply with applicable healthcare privacy regulations. Review our Privacy Policy and Notice of Privacy Practices for details."
  }
];

export const mockTrustBadges = [
  {
    id: 1,
    title: "HIPAA-Aligned",
    description: "Strong privacy safeguards",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Licensed Providers",
    description: "Board-certified professionals",
    icon: "Award"
  },
  {
    id: 3,
    title: "Secure Video",
    description: "Encrypted connections",
    icon: "Video"
  },
  {
    id: 4,
    title: "Transparent Pricing",
    description: "Know costs upfront",
    icon: "DollarSign"
  }
];

export const mockStates = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
  "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho",
  "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana",
  "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
  "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
  "New Hampshire", "New Jersey", "New Mexico", "New York",
  "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon",
  "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
  "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
  "West Virginia", "Wisconsin", "Wyoming"
];
